// * Module-level store for the bypass token received from the connector via CONVERSED_READY.
// * Lives in memory (not localStorage) - scoped to the page session, cleared on reload.
// * Only one token is held at a time; calling init() more than once on the same page is unsupported.
let bypassToken: string | null = null;

export const storeBypassToken = (token: string | null) => {
  bypassToken = token;
};

export const getBypassToken = (): string | null => bypassToken;
